"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderHistoryTab = void 0;
const filter_header_1 = require("client/components/filter-header");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const select_1 = require("client/components/material/select");
const store_1 = require("client/modules/inventory-order/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const React = require("react");
const react_1 = require("react");
const purchase_order_1 = require("shared/purchase-order");
const formatUsd_1 = require("shared/util/formatUsd");
const throttle_debounce_1 = require("throttle-debounce");
require("./order-history.less");
const columns = [
    {
        label: "trans id",
        id: "id"
    },
    {
        label: "order cost",
        id: "orderTotalCost"
    },
    {
        label: "pharmacy",
        id: "pharmacyName"
    },
    {
        label: "order name",
        id: "orderName"
    },
    {
        label: "trans PO#",
        id: "transactionPONumber"
    },
    {
        label: "customer PO#",
        id: "customerPONumber"
    },
    {
        label: "status",
        id: "approvalStatus"
    },
    {
        label: "submission date",
        id: "submissionDate"
    },
    {
        label: "order description",
        id: "orderDescription"
    }
];
let OrderHistoryTab = class OrderHistoryTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.orderHistory = [];
        this.orderSiteId = 0;
        this.filterText = "";
        this.order = "DESC";
        this.orderBy = "id";
        this.loadPurchaseOrders = throttle_debounce_1.debounce(200, async (tmpSearch = false) => {
            this.orderHistory = await store_1.inventoryOrderStore.loadPurchaseOrders({
                count: 100,
                order: this.order,
                search: this.filterText,
                sort: this.orderBy,
                start: 0,
                siteId: tmpSearch ? null : this.orderSiteId
            });
        });
        this.onCallback = (value) => {
            const isTmp = store_3.usersStore.user.value.user;
            this.filterText = value;
            if (isTmp && this.filterText) {
                const tmpSearch = true;
                this.loadPurchaseOrders(tmpSearch);
            }
            else {
                this.loadPurchaseOrders();
            }
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadPurchaseOrders();
        };
        this.handleChangeSite = async (id) => {
            this.orderSiteId = Number(id);
            this.loadPurchaseOrders();
        };
        this.getStatusText = (approvalStatus) => {
            let statusText = "";
            switch (approvalStatus) {
                case purchase_order_1.POStatus.Approved:
                    statusText = "Pending Delivery";
                    break;
                case purchase_order_1.POStatus.Rejected:
                    statusText = "Rejected";
                    break;
                case purchase_order_1.POStatus.Pending:
                case purchase_order_1.POStatus.Resubmitted:
                    statusText = "Pending Approval";
                    break;
                case purchase_order_1.POStatus.Canceled:
                    statusText = "Canceled";
                    break;
                default:
                    break;
            }
            return statusText;
        };
        this.renderOrderHistoryListRow = (row, index) => {
            const { id, approvalStatus, customerPONumber, orderTotalCost, pharmacyName, submissionDate, transactionPONumber, orderName, orderInventories, orderDescription, purchaseOrderDistributorInvoices: invoices } = row;
            const allProductsReceived = invoices &&
                invoices.length &&
                invoices.every((invoice) => invoice.productReceived);
            const allPoiCanceled = orderInventories.every(poi => Boolean(poi.canceledAt));
            if (!invoices || !invoices.length) {
                console.error('No invoices found');
            }
            else {
                console.info('invoices length', invoices.length);
            }
            const statusText = allProductsReceived && !allPoiCanceled
                ? "Complete"
                : this.getStatusText(approvalStatus);
            const orderTotalCostCurrencyFormat = formatUsd_1.formatUsd(Number(orderTotalCost));
            return (React.createElement(list_item_1.MaterialListItem, { key: index, to: `/order/review/${id}`, className: `order-list-item--order-history po-status-${approvalStatus}` },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: id }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: orderTotalCostCurrencyFormat }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: pharmacyName }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: orderName || "n/a" }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: transactionPONumber }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: customerPONumber }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: statusText }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: moment(submissionDate).format("MM/DD/YYYY") }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: orderDescription })));
        };
        this.renderOrderHistoryList = () => (React.createElement(list_1.MaterialList, { className: "order-history-list", columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: this.orderHistory || [], renderRow: this.renderOrderHistoryListRow, resizableheader: true, customClass: "custom-material-list__order-history-list" }));
    }
    get availableOptions() {
        return store_2.sitesListStore.sites.value
            ? store_2.sitesListStore.sites.value.map((site, i) => ({
                id: i,
                label: site.displayName || site.name,
                value: site.id.toString()
            }))
            : [];
    }
    async componentWillMount() {
        store_2.sitesListStore.loadSitesNoRelation(); // @tkay load sites no relations
        this.orderSiteId =
            store_3.usersStore.user && store_3.usersStore.user.value && store_3.usersStore.user.value.siteId
                ? store_3.usersStore.user.value.siteId
                : 0;
        this.loadPurchaseOrders();
    }
    render() {
        return (React.createElement("div", { className: "inventory-order__order-templates" },
            React.createElement(material_ui_1.Typography, { variant: "display1" }, "Order history"),
            store_3.usersStore.permissions.ReadPharmacies && (React.createElement("div", { className: "order-templates__button" },
                React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, value: String(this.orderSiteId) || "" }))),
            React.createElement(filter_header_1.FilterHeader, { label: "Search", title: "Purchase Order", callBack: this.onCallback, filterText: this.filterText }),
            this.renderOrderHistoryList()));
    }
};
__decorate([
    mobx_1.computed
], OrderHistoryTab.prototype, "availableOptions", null);
__decorate([
    mobx_1.observable
], OrderHistoryTab.prototype, "orderHistory", void 0);
__decorate([
    mobx_1.observable
], OrderHistoryTab.prototype, "orderSiteId", void 0);
__decorate([
    mobx_1.observable
], OrderHistoryTab.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], OrderHistoryTab.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], OrderHistoryTab.prototype, "orderBy", void 0);
__decorate([
    mobx_1.action
], OrderHistoryTab.prototype, "onCallback", void 0);
__decorate([
    mobx_1.action
], OrderHistoryTab.prototype, "handleChangeSite", void 0);
OrderHistoryTab = __decorate([
    mobx_react_1.observer
], OrderHistoryTab);
exports.OrderHistoryTab = OrderHistoryTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-history/order-history.tsx
// module id = 3567
// module chunks = 0